export default {
  rtlLangIsoCodes: ['ar', 'he'],
  convertLocaleCodeToIsoCode(localeCode: string, separator: string = '-'): string {
    return localeCode?.split(separator)?.[0].toLocaleLowerCase();
  },
  getLangDirectionByLangLocaleCode(localeCode: string): string {
    const isoCode = this.convertLocaleCodeToIsoCode(localeCode);
    const direction = this.rtlLangIsoCodes.includes(isoCode) ? 'rtl' : 'ltr';

    return direction;
  },
  isLangRtl(localeCode: string): boolean {
    return this.getLangDirectionByLangLocaleCode(localeCode) === 'rtl';
  },
  setLagAndDirOnHtmlByLangCode(localeCode: string): void {
    const langDirection = this.getLangDirectionByLangLocaleCode(localeCode);

    const htmlEl = document.querySelector('html');
    htmlEl?.setAttribute('dir', langDirection ?? 'ltr');
    htmlEl?.setAttribute('lang', localeCode ?? 'en');
  },
};
